import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from '../_helper/Auth/AuthProvider';
import Loader from "../Layout/Loader";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";
import Error503 from "../Components/Pages/ErrorPages/ErrorPage503";
import { getRedirectPath, needsEducationalLevel, needsSubscription } from "./redirectUtils";

const PrivateRoute = ({ roles }) => {
  const location = useLocation();
  const { authenticated, userData, loading, error } = useAuth();

  // Get the current path
  const currentPath = location.pathname;

  // console.log("PrivateRoute - Current path:", currentPath);
  // console.log("PrivateRoute - userData:", userData);

  if (loading) {
    return <Loader />;
  }

  if (error && error === 'Network Error') {
    return <Error503 />;
  }

  if (!authenticated || !userData) {
    return <Navigate to={getRedirectPath(authenticated, userData)} />;
  }

  // Check if user has the required role
  if (roles && roles.indexOf(userData.role) === -1) {
    return <Error403 />;
  }

  // Special check for 'user' role: if they need educational level and trying to access app routes
  if (userData.role === 'user' &&
    needsEducationalLevel(userData) &&
    location.pathname.startsWith('/app/')) {
    // console.log("Redirecting user to educational level selection");
    return <Navigate to="/auth/register/educational-level" />;
  }

  // Check if user needs to select a subscription plan
  // IMPORTANT: Only check for app routes, not auth routes
  const isAppRoute = currentPath.startsWith('/app/');
  const isBillingPage = currentPath === '/auth/register/billing';
  const isCheckoutPage = currentPath === '/auth/checkout';
  const isPaymentProcessing = currentPath === '/auth/checkout' && location.state?.isProcessing;

  // Only redirect if:
  if (userData.role === 'user' &&
    needsSubscription(userData) &&
    isAppRoute &&
    !isBillingPage &&
    !isCheckoutPage &&
    !isPaymentProcessing) {
    // Log the reason for redirect
    if (userData.subscription && userData.subscription.status === 'expired') {
      // console.log("Redirecting user to billing page - subscription expired");
    } else if (userData.subscription && userData.subscription.status === 'canceled') {
      // console.log("Redirecting user to billing page - subscription canceled");
    } else {
      // console.log("Redirecting user to billing page - no active subscription");
    }
    return <Navigate to="/auth/register/billing" />;
  }

  return <Outlet />;
};

export default PrivateRoute;